<template>
  <div class="scroll-horizontal">
    <table class="fundo-tabela mt-10" v-if="dados.macroprocessos.length">
        <thead class="titulo">
            <tr>
                <th 
                class="titulo-tabela-interrompido"
                :colspan="(qtdCategoriasAging * dados.macroprocessos.length) + 6"
                ><b>INTERROMPIDO</b></th>
            </tr>
            <tr class="white--text">
                <th class="fundo-primeira-coluna"></th>
                <th
                    v-for="(macroprocesso, index) in dados.macroprocessos"
                    :colspan="qtdCategoriasAging"
                    :key="index"
                    :style="'background-color: '+definirArrayECorMacroProcesso(macroprocesso.ctrl_macro_processo_id, index)"
                    :class="getBordaMacroProcesso(index)"
                >{{ macroprocesso.macro_processo }}
                    <span class="d-block cursor-pointer" @click="detalharTarefas($event,null,null,macroprocesso.ctrl_macro_processo_id)">
                        {{macroprocesso.aging.aging_total}}
                    </span>
                </th>
            </tr>
            <tr>
                <th class="fundo-primeira-coluna"></th>
                <th
                    v-for="(titulo, index) in titulosAging"
                    :key="'titulo_'+index"
                    :style="'color: '+coresAgings[index]"
                    :class="`vertical-text${getBordaAging(index)} ${ehColunaTotal(index)}`"
                >{{ titulo }}
                </th>
            </tr>
        </thead>
        <tbody class="dados-aging">
            <tr v-for="(familia, index) in dados.familias" :key="'familia_'+index">
                <td class="fundo-primeira-coluna borda-primeirac">{{ familia.familia }}</td>

                <td v-for="(agingMacroProcesso, indexFamiliaAgingMacro) in familia.agings"
                    :key="'index_aging_'+indexFamiliaAgingMacro"
                    :class="`${getBgAging(indexFamiliaAgingMacro, familia.ctrl_familia_id)}${getBordaAging(indexFamiliaAgingMacro)} ${ehColunaTotal(indexFamiliaAgingMacro)}` "
                >
                  <span class="cursor-pointer" @click="detalharTarefasPorFamilia($event,familia.ctrl_familia_id,indexFamiliaAgingMacro)">
                    {{ agingMacroProcesso }} 
                  </span>
                </td>
            </tr>
            <tr>
              <td class=" font-weight-bold fundo-primeira-coluna borda-primeirac">Total Geral</td>
              <td
                v-for="(total, index) in dados.total_por_aging"
                :key="'total_'+index"
                :class="`${getBordaAging(index)} ${ehColunaTotal(index, true)}`"
              >
                <span class="cursor-pointer font-weight-bold" @click="detalharTarefasPorMacroProcesso($event,index)">
                  {{ total }}
                </span>
              </td>
            </tr>
        </tbody>
    </table>
    <SGPAlertaComponent v-else>Dados não encontrados</SGPAlertaComponent>
  </div>
</template>
  
  <script>
  export default {
    name: "TabelaBacklogTarefaInterrupcaoComponent",
    props: {
      dados: {
        type: Object,
        required: true
      }
    },
  
    mounted() {
      document.documentElement.style.overflowX = 'scroll';
    },

    beforeDestroy() {
        document.documentElement.style.overflowX = '';
    },
    
    data() {
      return {
        cores: ['#83170F','#DA291C','#B84D01','#FB9C2D','#00818F'],
        coresAgings: [],
        dadosAgings: [],
        descAgings: [
            '0',
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8_10',
            '11_15',
            '16_30',
            '31_60',
            'maior_60',
            'total'
        ],
        agingValor: {
            '0': 0,
            '1': 1,
            '2': 2,
            '3': 3,
            '4': 4,
            '5': 5,
            '6': 6,
            '7': 7,
            '8_10': 10,
            '11_15': 15,
            '16_30': 30,
            '31_60': 60,
            'maior_60': 61,
            'total': 61
        },
        qtdCategoriasAging: 14,
        // titulosAging: this.getTitulosAging(),
        classBordaDestaque: ' borda-macroprocesso '
      }
    },
  
    methods: {
        getBordaMacroProcesso (indexM) {
            if(indexM + 1 != this.dados.macroprocessos.length){ 
                return this.classBordaDestaque;
            }
            return '';
        },
        
        getBordaAging (index) {
            if(this.dadosAgings[index-1]?.aging == 'maior_60' &&
              index + 1 < this.dadosAgings.length) { 
                return this.classBordaDestaque;
            }
            return '';
        },

        getBgAging (indexFamiliaAgingMacro, ctrlFamiliaId) {
          let prazoCtrlTarefa = this.buscarPrazoCtrlTarefa(this.dadosAgings[indexFamiliaAgingMacro]?.ctrlMacroProcessoId,ctrlFamiliaId);

            let agingAtual = this.agingValor[this.dadosAgings[indexFamiliaAgingMacro]?.aging];
            if (prazoCtrlTarefa != null && agingAtual > prazoCtrlTarefa) {
                return ' bg-vencido ';
            }
            return '';
        },

        buscarPrazoCtrlTarefa(ctrlMacroProcessoId, ctrlFamiliaId) {
          let macroProcesso = this.dados.macroprocessos.filter(item => { return item.ctrl_macro_processo_id == ctrlMacroProcessoId })[0];  
          if (macroProcesso?.familias) {
            let familiaFiltrada = macroProcesso.familias.filter(item => { return item.ctrl_familia_id == ctrlFamiliaId})[0];

            if (typeof familiaFiltrada != 'undefined') {
              return familiaFiltrada.prazo_ctrl_tarefa;
            }
          }
          
          return null;
        },

        detalharTarefasPorMacroProcesso(event,indexFamiliaAgingMacro) {
          const ctrlFamiliaId = null;
          this.detalharTarefas (
            event,
            ctrlFamiliaId,
            this.dadosAgings[indexFamiliaAgingMacro].aging,
            this.dadosAgings[indexFamiliaAgingMacro].ctrlMacroProcessoId
          );
        },

        detalharTarefasPorFamilia(event,ctrlFamiliaId,indexFamiliaAgingMacro) {
          this.detalharTarefas(
            event,
            ctrlFamiliaId,
            this.dadosAgings[indexFamiliaAgingMacro].aging,
            this.dadosAgings[indexFamiliaAgingMacro].ctrlMacroProcessoId
          );
        },

        detalharTarefas(event,ctrlFamiliaId,aging,ctrlMacroProcessoId=null) {
            const ctrlTarefa = null;
            const interrupcoes = true;
            this.$emit('detalharTarefasEmit', {
                event,
                ctrlMacroProcessoId,
                ctrlTarefa,
                aging,
                ctrlFamiliaId,
                interrupcoes
            });
        },

        getTitulosAging () {
            let titulos = [];
 
            for(let i=0; i< this.dados.macroprocessos.length; ++i) {
                titulos = titulos.concat([
                    '0','1','2','3','4','5','6','7','8 a 10',
                    '11 a 15','16 a 30','31 a 60','> 60', 'Total'
                ]);
            }
            return titulos;
        },

        setCorEArrayFamilias(cor,ctrlMacroProcessoId) {
          let posInicial = this.dadosAgings.length;
          let posFinal = posInicial + this.qtdCategoriasAging;
          let posAging = 0;

          for(let j = posInicial;j < posFinal; ++j) {
              this.coresAgings[j] = cor;
              this.dadosAgings[j] = {
                ctrlMacroProcessoId : ctrlMacroProcessoId,
                aging: this.descAgings[posAging]
              }
              posAging++;
          }
        },

        definirArrayECorMacroProcesso(ctrlMacroProcessoId, indice) {
          let corSelecionada = this.cores[(indice % 5)];  
          this.setCorEArrayFamilias(corSelecionada,ctrlMacroProcessoId);
          return corSelecionada;
        },

        ehColunaTotal (index, totalGeral = false) {
          if ((index % this.qtdCategoriasAging) + 1  == this.qtdCategoriasAging) {
            return totalGeral ? 'bg-coluna-total-geral' : 'bg-coluna-total'
          }
          return ''
        }
    },
    computed: {
      total() {
        return (
          this.qtdDefinirSolucao +
          this.qtdConstruirAcesso +
          this.qtdAprovisionarServico +
          this.qtdPrepararAtivacao +
          this.qtd_ativar_servico
        );
      },

      titulosAging () {
        let titulos = [];

        if (this.dados.macroprocessos) {
          for(let i=0; i< this.dados.macroprocessos.length; ++i) {
              titulos = titulos.concat([
                  '0','1','2','3','4','5','6','7','8 a 10',
                  '11 a 15','16 a 30','31 a 60','> 60', 'Total'
              ]);
          }
        }
        return titulos;
    },
    },
  };
  </script>